import { colours } from "@shared/ui.design-system"
import { HeartIcon } from "@shared/ui.icons"
import { Button } from "@shared/ui.primitives"

import * as styles from "./WishlistButton.css"

type WishilistButtonProps = {
  isInWishlist: boolean
  handleWishlist: () => void
}

export const WishlistButton: React.FC<WishilistButtonProps> = ({
  isInWishlist,
  handleWishlist,
}) => {
  return (
    <div className={styles.wishlistButtonContainer}>
      <Button
        variant="primary"
        width="full"
        ariaLabel="Add to wishlist"
        text=""
        onClick={handleWishlist}
        leftIcon={
          <HeartIcon
            width={20}
            height={20}
            fill={
              isInWishlist ? colours.accent.medium : colours.secondary.light
            }
          />
        }
      ></Button>
    </div>
  )
}
